import { createContext, useEffect, useReducer } from "react";
import axios from "axios";
import { WebUrl } from "app/utils/constant";
import { useNavigate } from "react-router-dom";

const initialState = {
  user: null,
  isInitialized: false,
  isAuthenticated: false
};

const reducer = (state, action) => {
  switch (action.type) {
    case "INIT": {
      const { isAuthenticated, user } = action.payload;
      return { ...state, isAuthenticated, isInitialized: true, user };
    }

    case "LOGIN": {
      return { ...state, isAuthenticated: true, user: action.payload.user };
    }

    case "LOGOUT": {
      return { ...state, isAuthenticated: false, user: null };
    }

    case "REGISTER": {
      const { user } = action.payload;

      return { ...state, isAuthenticated: true, user };
    }

    default:
      return state;
  }
};

const AuthContext = createContext({
  ...initialState,
  method: "JWT",
  login: () => {},
  loginSalesman: () => {},
  logout: () => {},
  register: () => {}
});

function parseJwt(token) {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error('Invalid token');
    return null;
  }
}

export const AuthProvider = ({ children }) => {
  const navigate = useNavigate();
  const [state, dispatch] = useReducer(reducer, initialState);

  const login = async (email, password) => {
    const response = await axios.post(WebUrl +"auth/jwt/create/", { email: email.toLowerCase(), password });
    const { refresh, access } = response.data;
    localStorage.setItem('refreshToken', refresh);
    localStorage.setItem('accessToken', access);
    const decodedToken = parseJwt(access);
    dispatch({ type: "LOGIN", payload: { user: decodedToken } });
    return decodedToken;
  };

  const logout = () => {
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('accessToken');
    dispatch({ type: "LOGOUT" });
    dispatch({ type: "INIT", payload: { isAuthenticated: true, isInitialized: true, user: null } });
    navigate("/session/logout");
  };

  useEffect(() => {
    (async () => {
      try {
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
          const decodedToken = parseJwt(accessToken);
          dispatch({ type: "LOGIN", payload: { isAuthenticated: true, user: decodedToken } });
        } else {
          dispatch({ type: "INIT", payload: { isAuthenticated: true, isInitialized: true, user: null } });
        }
      } catch (err) {
        console.error(err);
        dispatch({ type: "INIT", payload: { isAuthenticated: false, user: null } });
      }
    })();
  }, []);

  return (
    <AuthContext.Provider value={{ ...state, method: "JWT", login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
